export const mockFoodData = {
    "statusCode": 0,
    "data": {
    "statusMessage": "done successfully",
    "cards": [
    {
    "card": {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
    "info": {
    "id": "32398",
    "name": "The Bowl Company",
    "city": "Bangalore",
    "slugs": {
    "restaurant": "the-bowl-company-marathahalli",
    "city": "bangalore"
    },
    "uniqueId": "0af24804-6a70-4a98-b733-bc1efdeb3402",
    "cloudinaryImageId": "bb6049fae59b8a2413a9177eb0338b49",
    "locality": "Munnekollal",
    "areaName": "Marathahalli",
    "costForTwo": "30000",
    "costForTwoMessage": "₹300 for two",
    "cuisines": [
    "Pan-Asian",
    "Continental"
    ],
    "avgRating": 4.3,
    "feeDetails": {
    "restaurantId": "32398",
    "fees": [
    {
    "name": "distance",
    "fee": 4000
    },
    {
    "name": "time"
    },
    {
    "name": "special"
    }
    ],
    "totalFee": 4000,
    "title": "Delivery Charge",
    "amount": "4000"
    },
    "parentId": "4317",
    "avgRatingString": "4.3",
    "totalRatingsString": "10K+ ratings",
    "sla": {
    "restaurantId": "32398",
    "deliveryTime": 33,
    "minDeliveryTime": 33,
    "maxDeliveryTime": 33,
    "lastMileTravel": 4.3,
    "serviceability": "SERVICEABLE",
    "stressFactor": 0.662997,
    "rainMode": "RAIN_MODE_NONE",
    "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
    "zoneId": 6,
    "slaString": "33 MINS",
    "lastMileTravelString": "4.3 km",
    "iconType": "ICON_TYPE_EMPTY"
    },
    "availability": {
    "nextCloseTime": "2023-06-17 02:00:00",
    "visibility": true,
    "opened": true,
    "restaurantClosedMeta": {}
    },
    "aggregatedDiscountInfo": {
    "header": "60% off",
    "shortDescriptionList": [
    {
    "meta": "60% off | Use TRYNEW",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    },
    {
    "meta": "FLAT110 off | Use DNBINGE",
    "discountType": "Flat",
    "operationType": "RESTAURANT"
    }
    ],
    "descriptionList": [
    {
    "meta": "60% off up to ₹100 | Use code TRYNEW",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    },
    {
    "meta": "FLAT110 off | Use DNBINGE",
    "discountType": "Flat",
    "operationType": "RESTAURANT"
    }
    ],
    "visible": true
    },
    "badges": {},
    "slugString": "the-bowl-company-marathahalli",
    "multiOutlet": true,
    "isOpen": true,
    "labels": [
    {
    "title": "Timings",
    "message": "null"
    },
    {
    "title": "Address",
    "message": "sai tower,1st floor munnekolala varthur hobli,maratahalli,bangalore-560036"
    },
    {
    "title": "Cuisines",
    "message": "Pan-Asian,Continental"
    }
    ],
    "logo": "marketing-dashboard/carousel/kcnahrbhty9uv8uraow4",
    "totalRatings": 10000,
    "aggregatedDiscountInfoV2": {
    "header": "60% off",
    "shortDescriptionList": [
    {
    "meta": "60% off | Use TRYNEW",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    },
    {
    "meta": "FLAT110 off | Use DNBINGE",
    "discountType": "Flat",
    "operationType": "RESTAURANT"
    }
    ],
    "descriptionList": [
    {
    "meta": "60% off up to ₹100 | Use code TRYNEW",
    "discountType": "Percentage",
    "operationType": "RESTAURANT"
    },
    {
    "meta": "FLAT110 off | Use DNBINGE",
    "discountType": "Flat",
    "operationType": "RESTAURANT"
    }
    ],
    "couponDetailsCta": "View coupon details"
    },
    "type": "F",
    "nudgeBanners": [
    {
    "minValue": 223,
    "maxValue": 319,
    "priority": 2,
    "couponCode": "DNBINGE",
    "discountInfo": {
    "discountType": "Flat",
    "value": 110
    },
    "lockedMessage": "Add items worth ₹<amount> to save ₹110 | Code DNBINGE",
    "unlockedMessage": "DNBINGE Coupon Unlocked! Use it to save ₹110",
    "logoCtx": {}
    },
    {
    "minValue": 560,
    "maxValue": 800,
    "priority": 3,
    "couponCode": "PARTY",
    "discountInfo": {
    "discountType": "Percentage",
    "value": 15
    },
    "lockedMessage": "Add items worth ₹<amount> to unlock flat 15% off | Code PARTY",
    "unlockedMessage": "PARTY Coupon Unlocked! Use it to save flat 15% off",
    "logoCtx": {}
    }
    ],
    "headerBanner": {
    "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/32398"
    },
    "expectationNotifiers": [
    {
    "icon": {},
    "popup": {
    "cta": {}
    },
    "type": "DISTANCE_FEE_NON_FOOD_LM",
    "halfCardPopup": {
    "halfCardPopupHeader": {}
    }
    }
    ],
    "generalPurposeInfoListV2": [
    {
    "cta": {
    "info": {
    "recordings": {}
    },
    "linkCta": {}
    }
    }
    ],
    "ratingSlab": "RATING_SLAB_5",
    "orderabilityCommunication": {
    "title": {},
    "subTitle": {},
    "message": {},
    "customIcon": {}
    },
    "hasBestsellerItems": true,
    "hasGuiltfreeItems": true,
    "cartOrderabilityNudgeBanner": {
    "parameters": {},
    "presentation": {}
    },
    "areaPostalCode": "560037",
    "latLong": "12.955408,77.71304499999997"
    },
    "analytics": {}
    },
    "relevance": {
    "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
    "sectionId": "POP_UP_CROUTON_MENU"
    }
    }
    },
    {
    "card": {
    "card": {
    "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
    "layout": {
    "rows": 1,
    "columns": 5,
    "horizontalScrollEnabled": true,
    "itemSpacing": 12,
    "lineSpacing": 10,
    "widgetPadding": {},
    "containerStyle": {
    "containerPadding": {
    "left": 10,
    "right": 10,
    "bottom": 16
    }
    },
    "scrollBar": {}
    },
    "id": "offerCollectionWidget_UX4",
    "gridElements": {
    "infoWithStyle": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
    "offers": [
    {
    "info": {
    "header": "60% OFF UPTO ₹100",
    "offerTagColor": "#E46D47",
    "offerIds": [
    "4099cf81-8b77-4a1e-bb1d-4f79c3002145"
    ],
    "expiryTime": "1970-01-01T00:00:00Z",
    "couponCode": "USE TRYNEW",
    "description": "ABOVE ₹159",
    "offerType": "offers",
    "restId": "32398",
    "offerLogo": "offers/generic",
    "descriptionTextColor": "#7302060C"
    },
    "cta": {
    "type": "OFFER_HALF_CARD"
    }
    },
    {
    "info": {
    "header": "FLAT ₹110 OFF",
    "offerTag": "DINNER",
    "offerTagColor": "#E46D47",
    "offerIds": [
    "a00d4c79-bd12-456b-9490-7a58e6b61645"
    ],
    "expiryTime": "1970-01-01T00:00:00Z",
    "couponCode": "USE DNBINGE",
    "description": "ABOVE ₹319",
    "offerType": "offers",
    "restId": "32398",
    "offerLogo": "offers/generic",
    "descriptionTextColor": "#7302060C"
    },
    "cta": {
    "type": "OFFER_HALF_CARD"
    }
    },
    {
    "info": {
    "header": "FLAT 15% OFF",
    "offerTag": "FLAT DEAL",
    "offerTagColor": "#E46D47",
    "offerIds": [
    "c2d156e3-8f2e-43af-b325-3d1748517d64"
    ],
    "expiryTime": "1970-01-01T00:00:00Z",
    "couponCode": "USE PARTY",
    "description": "ABOVE ₹800",
    "offerType": "offers",
    "restId": "32398",
    "offerLogo": "offers/generic",
    "descriptionTextColor": "#7302060C"
    },
    "cta": {
    "type": "OFFER_HALF_CARD"
    }
    },
    {
    "info": {
    "header": "20% OFF UPTO ₹100",
    "offerTagColor": "#E46D47",
    "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
    "offerIds": [
    "47574678-35e3-44b7-984b-92f2cfeb9d44"
    ],
    "expiryTime": "1970-01-01T00:00:00Z",
    "couponCode": "USE RUPAY100",
    "description": "ABOVE ₹129",
    "offerType": "offers",
    "restId": "32398",
    "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
    "descriptionTextColor": "#7302060C"
    },
    "cta": {
    "type": "OFFER_HALF_CARD"
    }
    },
    {
    "info": {
    "header": "20% OFF UPTO ₹150",
    "offerTagColor": "#E46D47",
    "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
    "offerIds": [
    "007fd412-5fa3-4aa6-87d6-10a234fb10a2"
    ],
    "expiryTime": "1970-01-01T00:00:00Z",
    "couponCode": "USE ICICIFEST",
    "description": "ABOVE ₹600",
    "offerType": "offers",
    "restId": "32398",
    "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
    "descriptionTextColor": "#7302060C"
    },
    "cta": {
    "type": "OFFER_HALF_CARD"
    }
    }
    ]
    }
    }
    }
    }
    },
    {
    "groupedCard": {
    "cardGroupMap": {
    "REGULAR": {
    "cards": [
    {
    "card": {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
    "badges": {},
    "vegOnlyDetails": {
    "imageId": "AutoVegOnly_qkjowj",
    "title": "Showing only vegetarian options.",
    "description": "Tap on the VEG ONLY button to turn off the setting"
    },
    "topRatedFilter": {}
    }
    }
    },
    {
    "card": {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
    "title": "Top Picks",
    "carousel": [
    {
    "type": "TopCarousel",
    "subtype": "image",
    "bannerId": "1060858",
    "creativeId": "TopPicks/MFCwSR",
    "title": "Malabar Fish Curry with Steamed Rice",
    "description": " ",
    "fontColor": "#FFFFFF",
    "dish": {
    "info": {
    "id": "111875286",
    "name": "Malabar Fish Curry with Steamed Rice",
    "category": "Chef's Special",
    "description": "Kerala-style fish curry cooked the traditional way with a delicious gravy of tamarind, coconut and curry leaves. Relish with steamed rice for a classic coastal meal. Contains fish, milk. Energy : 548 Kcal (Mini), 756 Kcal (Regular). (Mini : 375 gms, Regular : 550 gms). (Mini : 375 gms, Regular : 550 gms).",
    "imageId": "5cbb169fc11ecf3e78aea750a396b33c",
    "inStock": 1,
    "price": 22900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566571",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679465",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679466",
    "name": "Regular",
    "price": 9900,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566572",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566573",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG"
    },
    "ribbon": {},
    "itemBadge": {},
    "badgesV2": {}
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "type": "TopCarousel",
    "subtype": "image",
    "bannerId": "1060942",
    "creativeId": "TopPicks/NPLwMP",
    "title": "Nawabi Paneer Lababdar with Matar Pulao",
    "description": " ",
    "fontColor": "#FFFFFF",
    "dish": {
    "info": {
    "id": "53696654",
    "name": "Nawabi Paneer Lababdar with Matar Pulao",
    "category": "Chef's Special",
    "description": "Serves 1 | Feel like a Nawab with this one, soft cubes of paneer cooked in a flavourful Chef special gravy, served along with aromatic matar pulao. Contains milk, nuts. Energy : 989 Kcal (Regular Bowl), 671 Kcal (Mini Bowl). (Mini : 375 gms, Regular : 550 gms).",
    "imageId": "c509f7678bd25b2be37fa6f9ebc2b215",
    "inStock": 1,
    "isVeg": 1,
    "price": 21900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566386",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679367",
    "name": "Mini",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679368",
    "name": "Regular",
    "price": 9000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566387",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566388",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566389",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {
    "text": "Bestseller",
    "textColor": "#ffffff",
    "topBackgroundColor": "#d53d4c",
    "bottomBackgroundColor": "#b02331"
    },
    "itemBadge": {},
    "badgesV2": {},
    "isBestseller": true
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "type": "TopCarousel",
    "subtype": "image",
    "bannerId": "1060984",
    "creativeId": "TopPicks/SCPwGFRB",
    "title": "Streetstyle Chilli Paneer with Garlic Rice Bowl",
    "description": " ",
    "fontColor": "#FFFFFF",
    "dish": {
    "info": {
    "id": "116359909",
    "name": "Streetstyle Chilli Paneer with Garlic Rice Bowl",
    "category": "Oriental Bowls",
    "description": "Paneer cooked with a tantalizing blend of garlic, ginger, soy sauce, and fiery red chillies. Served with a bed of fragrant garlic fried rice. Contains milk, wheat and soy. Energy : 841 Kcal (Mini), 1613 Kcal (Regular). This menu item contains added monosodium glutamate. Not recommended for infants below 12 months and pregnant women.",
    "imageId": "db0aada6571056c26742be0abffc538d",
    "inStock": 1,
    "isVeg": 1,
    "price": 21900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566707",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679567",
    "name": "Mini",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679568",
    "name": "Regular",
    "price": 10000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566708",
    "groupName": "Customization",
    "choices": [
    {
    "id": "92679002",
    "name": "None",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679003",
    "name": "Twist your dish with Chilli Garlic Sprinkler",
    "price": 1000,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566711",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566713",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566715",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "itemBadge": {},
    "badgesV2": {}
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "type": "TopCarousel",
    "subtype": "image",
    "bannerId": "1061026",
    "creativeId": "TopPicks/CM_CP",
    "title": "Classic Mac & Cheese Pasta",
    "description": " ",
    "fontColor": "#FFFFFF",
    "dish": {
    "info": {
    "id": "7993427",
    "name": "Classic Mac & Cheese Pasta",
    "category": "Continental Bowls",
    "description": "Serves 1 | Good 'ol aromatic and flavorsome bowl, creamy blend of aged cheese and macaroni, topped off with a herby thyme flavored crust! Twist your dish with a customizable option of Garlic Lemon Sprinkler. Contains wheat, milk. Energy : 755 Kcal (Regular Bowl), 556 Kcal (Mini Bowl) (Mini : 390 gms, Regular : 545 gms).",
    "imageId": "e22a283574072256420f52d992ec6887",
    "inStock": 1,
    "isVeg": 1,
    "price": 20900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566049",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92678998",
    "name": "Mini",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678999",
    "name": "Regular",
    "price": 9000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566051",
    "groupName": "Customization",
    "choices": [
    {
    "id": "92678868",
    "name": "None",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678869",
    "name": "Twist your dish with Garlic Lemon Sprinkler",
    "price": 1000,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566054",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566058",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566061",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566066",
    "groupName": "Sides",
    "choices": [
    {
    "id": "92678865",
    "name": "Mini Garlic Toast",
    "price": 4900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {
    "text": "Bestseller",
    "textColor": "#ffffff",
    "topBackgroundColor": "#d53d4c",
    "bottomBackgroundColor": "#b02331"
    },
    "itemBadge": {},
    "badgesV2": {},
    "isBestseller": true
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "type": "TopCarousel",
    "subtype": "image",
    "bannerId": "1061068",
    "creativeId": "TopPicks/CGCwHR",
    "title": "Caribbean Grilled Chicken with Herbed Rice",
    "description": " ",
    "fontColor": "#FFFFFF",
    "dish": {
    "info": {
    "id": "94877476",
    "name": "Caribbean Grilled Chicken with Herbed Rice",
    "category": "Chef's Special",
    "description": "Serves 1 | Tender and juicy grilled chicken breast cooked with caramelized onions, lemon-mustard sauce and served on a bed of flavourful and  herb rice. Served alongside a fiery peri peri sauce. Contains wheat, traces of soy. Energy : 533 Kcal (Mini Bowl), 670 Kcal (Regular Bowl) (425 gms). * This menu item contains added Monosodium Glutamate. Not recommended for infants below 12 months and pregnant women.",
    "imageId": "755e78cb4b93529a39950004c91871ca",
    "inStock": 1,
    "price": 22900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95565865",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92678866",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92678867",
    "name": "Regular",
    "price": 11000,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95565867",
    "groupName": "Customization",
    "choices": [
    {
    "id": "92678868",
    "name": "None",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678869",
    "name": "Twist your dish with Garlic Lemon Sprinkler",
    "price": 1000,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95565869",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565872",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565877",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565881",
    "groupName": "Sides",
    "choices": [
    {
    "id": "92678865",
    "name": "Mini Garlic Toast",
    "price": 4900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {
    "text": "Bestseller",
    "textColor": "#ffffff",
    "topBackgroundColor": "#d53d4c",
    "bottomBackgroundColor": "#b02331"
    },
    "itemBadge": {},
    "badgesV2": {},
    "isBestseller": true
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "type": "TopCarousel",
    "subtype": "image",
    "bannerId": "1061110",
    "creativeId": "TopPicks/PPCwECR",
    "title": "Peri Peri Chicken with Egg Corn Rice",
    "description": " ",
    "fontColor": "#FFFFFF",
    "dish": {
    "info": {
    "id": "94877446",
    "name": "Peri Peri Chicken with Egg Corn Rice",
    "category": "Chef's Special",
    "description": "Serves 1 | An irresistible combination of Portuguese inspired flavours. Tender peri peri grilled chicken on a bed of corn and egg rice, served with a portion of spicy peri peri sauce. Contains Egg, Milk, Traces of Soy. Energy = 995 Kcal (Regular Bowl). 657 Kcal (Mini Bowl). (Mini : 430 gms, Regular : 565 gms).",
    "imageId": "c81c2769f66e13d7b2f5773f5db699ce",
    "inStock": 1,
    "price": 22900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566468",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679416",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679417",
    "name": "Regular",
    "price": 11000,
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679418",
    "name": "Make it Guilt Free with Brown Rice (Mini)",
    "price": 4000,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566471",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566473",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566476",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {
    "text": "Bestseller",
    "textColor": "#ffffff",
    "topBackgroundColor": "#d53d4c",
    "bottomBackgroundColor": "#b02331"
    },
    "itemBadge": {},
    "badgesV2": {},
    "isBestseller": true
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    }
    ]
    }
    }
    },
    {
    "card": {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
    "title": "Chef's Special",
    "itemCards": [
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "53696654",
    "name": "Nawabi Paneer Lababdar with Matar Pulao",
    "category": "Chef's Special",
    "description": "Serves 1 | Feel like a Nawab with this one, soft cubes of paneer cooked in a flavourful Chef special gravy, served along with aromatic matar pulao. Contains milk, nuts. Energy : 989 Kcal (Regular Bowl), 671 Kcal (Mini Bowl). (Mini : 375 gms, Regular : 550 gms).",
    "imageId": "c509f7678bd25b2be37fa6f9ebc2b215",
    "inStock": 1,
    "isVeg": 1,
    "price": 21900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566386",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679367",
    "name": "Mini",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679368",
    "name": "Regular",
    "price": 9000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566387",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566388",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566389",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {
    "text": "Bestseller",
    "textColor": "#ffffff",
    "topBackgroundColor": "#d53d4c",
    "bottomBackgroundColor": "#b02331"
    },
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "isBestseller": true,
    "ratings": {
    "aggregatedRating": {
    "rating": "4.4",
    "ratingCount": "545 ratings",
    "ratingCountV2": "545"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "47420116",
    "name": "Drunken Chicken Garlic Fried Rice with Chilli Flakes",
    "category": "Chef's Special",
    "description": "Serves 1 | A fiery classic, inspired from the streets of Shanghai; tender chunks of chicken cooked in a Chef's special flavorful Asian sauce and served along with aromatic chilli garlic fried rice. . Contains wheat, traces of soy, . Energy : 521 Kcal (Mini Bowl) and 820 Kcal (Regular Bowl). (390 gms). * This menu item contains added Monosodium Glutamate. Not recommended for infants below 12 months and pregnant women.",
    "imageId": "6e979c036718ea5c009d49df219dba1e",
    "inStock": 1,
    "price": 21900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566214",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679177",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679178",
    "name": "Regular",
    "price": 10000,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566216",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566219",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566221",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {
    "text": "Bestseller",
    "textColor": "#ffffff",
    "topBackgroundColor": "#d53d4c",
    "bottomBackgroundColor": "#b02331"
    },
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "isBestseller": true,
    "ratings": {
    "aggregatedRating": {
    "rating": "4.2",
    "ratingCount": "342 ratings",
    "ratingCountV2": "342"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "94877446",
    "name": "Peri Peri Chicken with Egg Corn Rice",
    "category": "Chef's Special",
    "description": "Serves 1 | An irresistible combination of Portuguese inspired flavours. Tender peri peri grilled chicken on a bed of corn and egg rice, served with a portion of spicy peri peri sauce. Contains Egg, Milk, Traces of Soy. Energy = 995 Kcal (Regular Bowl). 657 Kcal (Mini Bowl). (Mini : 430 gms, Regular : 565 gms).",
    "imageId": "c81c2769f66e13d7b2f5773f5db699ce",
    "inStock": 1,
    "price": 22900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566468",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679416",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679417",
    "name": "Regular",
    "price": 11000,
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679418",
    "name": "Make it Guilt Free with Brown Rice (Mini)",
    "price": 4000,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566471",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566473",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566476",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {
    "text": "Bestseller",
    "textColor": "#ffffff",
    "topBackgroundColor": "#d53d4c",
    "bottomBackgroundColor": "#b02331"
    },
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "isBestseller": true,
    "ratings": {
    "aggregatedRating": {
    "rating": "4.4",
    "ratingCount": "701 ratings",
    "ratingCountV2": "701"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "94877476",
    "name": "Caribbean Grilled Chicken with Herbed Rice",
    "category": "Chef's Special",
    "description": "Serves 1 | Tender and juicy grilled chicken breast cooked with caramelized onions, lemon-mustard sauce and served on a bed of flavourful and  herb rice. Served alongside a fiery peri peri sauce. Contains wheat, traces of soy. Energy : 533 Kcal (Mini Bowl), 670 Kcal (Regular Bowl) (425 gms). * This menu item contains added Monosodium Glutamate. Not recommended for infants below 12 months and pregnant women.",
    "imageId": "755e78cb4b93529a39950004c91871ca",
    "inStock": 1,
    "price": 22900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95565865",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92678866",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92678867",
    "name": "Regular",
    "price": 11000,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95565867",
    "groupName": "Customization",
    "choices": [
    {
    "id": "92678868",
    "name": "None",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678869",
    "name": "Twist your dish with Garlic Lemon Sprinkler",
    "price": 1000,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95565869",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565872",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565877",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565881",
    "groupName": "Sides",
    "choices": [
    {
    "id": "92678865",
    "name": "Mini Garlic Toast",
    "price": 4900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {
    "text": "Bestseller",
    "textColor": "#ffffff",
    "topBackgroundColor": "#d53d4c",
    "bottomBackgroundColor": "#b02331"
    },
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "isBestseller": true,
    "ratings": {
    "aggregatedRating": {
    "rating": "4.4",
    "ratingCount": "294 ratings",
    "ratingCountV2": "294"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "111875286",
    "name": "Malabar Fish Curry with Steamed Rice",
    "category": "Chef's Special",
    "description": "Kerala-style fish curry cooked the traditional way with a delicious gravy of tamarind, coconut and curry leaves. Relish with steamed rice for a classic coastal meal. Contains fish, milk. Energy : 548 Kcal (Mini), 756 Kcal (Regular). (Mini : 375 gms, Regular : 550 gms). (Mini : 375 gms, Regular : 550 gms).",
    "imageId": "5cbb169fc11ecf3e78aea750a396b33c",
    "inStock": 1,
    "price": 22900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566571",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679465",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679466",
    "name": "Regular",
    "price": 9900,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566572",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566573",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.3",
    "ratingCount": "66 ratings",
    "ratingCountV2": "66"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    }
    ]
    }
    }
    },
    {
    "card": {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
    "title": "Continental Bowls",
    "itemCards": [
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "7993427",
    "name": "Classic Mac & Cheese Pasta",
    "category": "Continental Bowls",
    "description": "Serves 1 | Good 'ol aromatic and flavorsome bowl, creamy blend of aged cheese and macaroni, topped off with a herby thyme flavored crust! Twist your dish with a customizable option of Garlic Lemon Sprinkler. Contains wheat, milk. Energy : 755 Kcal (Regular Bowl), 556 Kcal (Mini Bowl) (Mini : 390 gms, Regular : 545 gms).",
    "imageId": "e22a283574072256420f52d992ec6887",
    "inStock": 1,
    "isVeg": 1,
    "price": 20900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566049",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92678998",
    "name": "Mini",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678999",
    "name": "Regular",
    "price": 9000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566051",
    "groupName": "Customization",
    "choices": [
    {
    "id": "92678868",
    "name": "None",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678869",
    "name": "Twist your dish with Garlic Lemon Sprinkler",
    "price": 1000,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566054",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566058",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566061",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566066",
    "groupName": "Sides",
    "choices": [
    {
    "id": "92678865",
    "name": "Mini Garlic Toast",
    "price": 4900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {
    "text": "Bestseller",
    "textColor": "#ffffff",
    "topBackgroundColor": "#d53d4c",
    "bottomBackgroundColor": "#b02331"
    },
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "isBestseller": true,
    "ratings": {
    "aggregatedRating": {
    "rating": "4.3",
    "ratingCount": "199 ratings",
    "ratingCountV2": "199"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "21352565",
    "name": "Creamy Mushroom Florentine Spaghetti Pasta",
    "category": "Continental Bowls",
    "description": "Serves 1 | A beauty straight from the cobbled stoned aisles of Italy! Al dente spaghetti tossed in a luscious creamy sauce along with mushrooms, lush spinach leaves and finished off with parmesan shavings. Simple, delicious and definitely worth a try. Contains milk, wheat. Energy : 884 Kcal (Regular Bowl), 595 Kcal (Mini Bowl) (Mini : 380 gms, Regular : 530 gms).",
    "imageId": "2e2b00fbe068d0e47e6a13a2e6557a82",
    "inStock": 1,
    "isVeg": 1,
    "price": 21900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566100",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679004",
    "name": "Mini",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679005",
    "name": "Regular",
    "price": 9000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566102",
    "groupName": "Customization",
    "choices": [
    {
    "id": "92678868",
    "name": "None",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678869",
    "name": "Twist your dish with Garlic Lemon Sprinkler",
    "price": 1000,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566106",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566109",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566111",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566115",
    "groupName": "Sides",
    "choices": [
    {
    "id": "92678865",
    "name": "Mini Garlic Toast",
    "price": 4900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.4",
    "ratingCount": "149 ratings",
    "ratingCountV2": "149"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "72051998",
    "name": "Butter Chicken Mac & Cheese",
    "category": "Continental Bowls",
    "description": "Serves 1 | A dish that marries the two classics - al dente macaroni and tender chicken chunks tossed in a creamy makhani sauce and finished off with parmesean shavings to seal the deal. Ultimate comfort food! Contains : Nut, milk, wheat. Energy : 869 Kcal (Regular Bowl), 565 Kcal (Mini Bowl). (530 gms).",
    "imageId": "041ce9063f9a81b0d21c1d6ef1c2cd0b",
    "inStock": 1,
    "price": 23900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95565840",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92678863",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92678864",
    "name": "Regular",
    "price": 10000,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95565844",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565847",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565850",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565854",
    "groupName": "Sides",
    "choices": [
    {
    "id": "92678865",
    "name": "Mini Garlic Toast",
    "price": 4900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.2",
    "ratingCount": "111 ratings",
    "ratingCountV2": "111"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    }
    ]
    }
    }
    },
    {
    "card": {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
    "title": "Oriental Bowls",
    "itemCards": [
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "116359908",
    "name": "Veg Manchurian with Chilli Garlic Rice Bowl",
    "category": "Oriental Bowls",
    "description": "Crispy fried veg balls dunked in classic Indo-Chinese manchurian gravy and servered with chilli garlic fried rice. Contains wheat and soy. Energy : 656 Kcal (Mini), 914 Kcal (Regular). This menu item contains added monosodium glutamate. Not recommended for infants below 12 months and pregnant women.",
    "imageId": "99a200610f81cdbde9c99a40a10a7a3b",
    "inStock": 1,
    "isVeg": 1,
    "price": 18900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566699",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679565",
    "name": "Mini",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679566",
    "name": "Regular",
    "price": 8000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566702",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566700",
    "groupName": "Customization",
    "choices": [
    {
    "id": "92679002",
    "name": "None",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679003",
    "name": "Twist your dish with Chilli Garlic Sprinkler",
    "price": 1000,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566704",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566705",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.1",
    "ratingCount": "12 ratings",
    "ratingCountV2": "12"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "7645965",
    "name": "Double Egg Fried Rice",
    "category": "Oriental Bowls",
    "description": "Serves 1 | A medley of scrambled eggs and seasonal veggies wok tossed along with rice and aromatic Chinese spices. Eggztravaganza! Contains Eggs, traces of soy. Energy : 750. 35 Kcal (Regular Bowl), 520 Kcal (Mini Bowl) (Mini : 350 gms, Regular : 550 gms). * This menu item contains added Monosodium Glutamate. Not recommended for infants below 12 months and pregnant women.",
    "imageId": "ab1993d8fd2350f9eeb5af1e20af0b2d",
    "inStock": 1,
    "price": 16900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566139",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679008",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679009",
    "name": "Regular",
    "price": 5000,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566141",
    "groupName": "Customization",
    "choices": [
    {
    "id": "92679002",
    "name": "None",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679003",
    "name": "Twist your dish with Chilli Garlic Sprinkler",
    "price": 1000,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566142",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566144",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566147",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.0",
    "ratingCount": "173 ratings",
    "ratingCountV2": "173"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "19808144",
    "name": "Classic Manchurian with Chilli Garlic Hakka Noodles",
    "category": "Oriental Bowls",
    "description": "Serves 1 | Mixed vegetable balls tossed in a thick manchurian gravy on a bed of tossed hakka noodles! Twist your dish with a customizable option of Chilli Garlic Sprinkler . Contains wheat, soy. Energy : 842 Kcal (Regular Bowl), 522 Kcal (Mini Bowl) (Mini : 450 gms, Regular : 625 gms). * This menu item contains added Monosodium Glutamate. Not recommended for infants below 12 months and pregnant women.",
    "imageId": "1382ee37bd20185a6527d32af8e3ce8a",
    "inStock": 1,
    "isVeg": 1,
    "price": 18900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566073",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679000",
    "name": "Mini",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679001",
    "name": "Regular",
    "price": 7000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566079",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566075",
    "groupName": "Customization",
    "choices": [
    {
    "id": "92679002",
    "name": "None",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679003",
    "name": "Twist your dish with Chilli Garlic Sprinkler",
    "price": 1000,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566083",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566086",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {
    "text": "Bestseller",
    "textColor": "#ffffff",
    "topBackgroundColor": "#d53d4c",
    "bottomBackgroundColor": "#b02331"
    },
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "isBestseller": true,
    "ratings": {
    "aggregatedRating": {
    "rating": "4.1",
    "ratingCount": "394 ratings",
    "ratingCountV2": "394"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "109163422",
    "name": "Thai Green Veg Curry with Steamed Rice",
    "category": "Oriental Bowls",
    "description": "Serves 1 | Locally sourced aubergine, beans and carrots cooked with coconut milk in a thai green curry paste; topped with fresh basil and red chilli. Served alongside with steamed rice. Contain traces of soy. Energy = 457 Kcal (Mini Bowl), 789.19 Kcal (Regular Bowl). (Mini : 390 gms, Regular : 550 gms).",
    "imageId": "c6c094d5d2e8c330e907638ef091a897",
    "inStock": 1,
    "isVeg": 1,
    "price": 19900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566509",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679423",
    "name": "Mini",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679424",
    "name": "Regular",
    "price": 8000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566512",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566515",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566517",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.5",
    "ratingCount": "150 ratings",
    "ratingCountV2": "150"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "116359907",
    "name": "Chilli Paneer with Garlic Hakka Noodles Bowl",
    "category": "Oriental Bowls",
    "description": "Spicy wok tossed noodles topped with paneer dunked in a spicy sauce made of chilli, soy sauce and garlic. Contains wheat, soy and milk. Energy : 912 Kcal (Mini), 1216 Kcal (Regular). This menu item contains added monosodium glutamate. Not recommended for infants below 12 months and pregnant women.",
    "imageId": "d4d822aeb6c54a32c5ae3ac03946d381",
    "inStock": 1,
    "isVeg": 1,
    "price": 21900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566689",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679563",
    "name": "Mini",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679564",
    "name": "Regular",
    "price": 10000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566691",
    "groupName": "Customization",
    "choices": [
    {
    "id": "92679002",
    "name": "None",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679003",
    "name": "Twist your dish with Chilli Garlic Sprinkler",
    "price": 1000,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566692",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566693",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566695",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.2",
    "ratingCount": "5 ratings",
    "ratingCountV2": "5"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "116359909",
    "name": "Streetstyle Chilli Paneer with Garlic Rice Bowl",
    "category": "Oriental Bowls",
    "description": "Paneer cooked with a tantalizing blend of garlic, ginger, soy sauce, and fiery red chillies. Served with a bed of fragrant garlic fried rice. Contains milk, wheat and soy. Energy : 841 Kcal (Mini), 1613 Kcal (Regular). This menu item contains added monosodium glutamate. Not recommended for infants below 12 months and pregnant women.",
    "imageId": "db0aada6571056c26742be0abffc538d",
    "inStock": 1,
    "isVeg": 1,
    "price": 21900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566707",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679567",
    "name": "Mini",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679568",
    "name": "Regular",
    "price": 10000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566708",
    "groupName": "Customization",
    "choices": [
    {
    "id": "92679002",
    "name": "None",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679003",
    "name": "Twist your dish with Chilli Garlic Sprinkler",
    "price": 1000,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566711",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566713",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566715",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "3.9",
    "ratingCount": "11 ratings",
    "ratingCountV2": "11"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "116359906",
    "name": "Drunken Chicken with Garlic Hakka Noodles Bowl",
    "category": "Oriental Bowls",
    "description": "Succulent chicken cooked in a delicious gravy with pan-asian flavours and a medley of colorful vegetables. Relish with wok tossed chilli garlic noodles. Contains wheat, soy, egg and fish. Energy : 697 Kcal (Mini), 956 Kcal (Regular). This menu item contains added monosodium glutamate. Not recommended for infants below 12 months and pregnant women.",
    "imageId": "015192d04224dc5fe69aa0c4003e40ff",
    "inStock": 1,
    "price": 21900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566684",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679561",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679562",
    "name": "Regular",
    "price": 10000,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566685",
    "groupName": "Customization",
    "choices": [
    {
    "id": "92679002",
    "name": "None",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679003",
    "name": "Twist your dish with Chilli Garlic Sprinkler",
    "price": 1000,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566686",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566687",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566688",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "5.0",
    "ratingCount": "3 ratings",
    "ratingCountV2": "3"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    }
    ]
    }
    }
    },
    {
    "card": {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
    "title": "Guilt Free Bowls",
    "itemCards": [
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "91350006",
    "name": "Good ol' Rajma Chawal with Brown Jeera Rice (Mini)",
    "category": "Guilt Free Bowls",
    "description": "Serves 1 | Classic comfort bowl consisting of red kidney beans cooked in a mildly spicy onion tomato masala gravy, served with cumin spiced brown rice. Contains : milk. Energy : 759 Kcal (Regular Bowl), 495 Kcal (Mini Bowl). (375 gms).",
    "imageId": "536dcb3b4b5bd0bfc54aea76f004d6db",
    "inStock": 1,
    "isVeg": 1,
    "price": 19900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566236",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566239",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566240",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "isGuiltfree": true,
    "ratings": {
    "aggregatedRating": {
    "rating": "4.1",
    "ratingCount": "153 ratings",
    "ratingCountV2": "153"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "91350009",
    "name": "Classic Chicken Curry with Brown Jeera Rice (Mini)",
    "category": "Guilt Free Bowls",
    "description": "Serves 1 | Food that speaks directly to the soul - bhuna chicken cooked in a rich tomato-onion gravy cooked with flavourful masalas and finished with fresh coriander served with jeera brown rice. Contains Nut . Energy : 792 Kcal (Regular Bowl) (375 gms).",
    "imageId": "adff901e67f47e4c8acfb1046200a37f",
    "inStock": 1,
    "price": 23900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95565917",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565920",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565926",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "isGuiltfree": true,
    "ratings": {
    "aggregatedRating": {
    "rating": "4.2",
    "ratingCount": "66 ratings",
    "ratingCountV2": "66"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "91350010",
    "name": "Classic Chicken Curry Laccha Parotta Bowl",
    "category": "Guilt Free Bowls",
    "description": "Serves 1 | Bhuna chicken cooked in a rich tomato-onion gravy cooked with flavourful masalas and finished with fresh coriander served with wheat laccha parotta. Contains : wheat, nut. Energy : 758. 3 Kcal (Mini Bowl), 1198 Kcal (Regular Bowl) (Mini : 385 gms, Regular : 600 gms).",
    "imageId": "9a7c22f34875a75106d50ce0ecbe6c29",
    "inStock": 1,
    "price": 24900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95565904",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92678872",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92678873",
    "name": "Regular",
    "price": 9900,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95565906",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565909",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565913",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "isGuiltfree": true,
    "ratings": {
    "aggregatedRating": {
    "rating": "4.4",
    "ratingCount": "79 ratings",
    "ratingCountV2": "79"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "91350011",
    "name": "Drunken Chicken Laccha Parotta Bowl",
    "category": "Guilt Free Bowls",
    "description": "Serves 1 | Tender chunks of chicken cooked in a Chef's special flavorful Asian sauce (tinch of wine) and served along with wheat laccha parotta. Contains wheat, traces of soy, fish crustaceans, molluscs (sauce) . Energy : 703 Kcal (Mini Bowl) (Mini : 385 gms, Regular : 600 gms).",
    "imageId": "ef08dd48636733e12cb31acee4362ef4",
    "inStock": 1,
    "price": 25900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566207",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679175",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679176",
    "name": "Regular",
    "price": 9900,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566209",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566210",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566211",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "isGuiltfree": true,
    "ratings": {
    "aggregatedRating": {
    "rating": "4.0",
    "ratingCount": "44 ratings",
    "ratingCountV2": "44"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "91350007",
    "name": "Peri Peri Chicken with Egg Corn Brown Fried Rice (Mini)",
    "category": "Guilt Free Bowls",
    "description": "Serves 1 | An irresistible combination of Portuguese flavours. Tender peri peri grilled chicken on a bed of corn and egg brown rice, served with a portion of spicy peri peri sauce. Contains Egg, milk, soy. Energy : 774 Kcal. (430 gms).",
    "imageId": "47e917ea95caec4a81386f134d764c8a",
    "inStock": 1,
    "price": 26900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566413",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566417",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566421",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "isGuiltfree": true,
    "ratings": {
    "aggregatedRating": {
    "rating": "4.5",
    "ratingCount": "171 ratings",
    "ratingCountV2": "171"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    }
    ]
    }
    }
    },
    {
    "card": {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
    "title": "Indian Bowls",
    "itemCards": [
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "88229214",
    "name": "Blissful Ghee Loaded Bisi Bele Bath (Mini)",
    "category": "Indian Bowls",
    "description": "Serves 1 | Spicy and tangy, with just the right amount of sweetness and heat. A classic from Karnataka, the dish features rice, lentils and vegetables cooked slowly in traditional spices, served with a generous dollop of ghee and crispy boondi. Blissful indeed. Contains milk, nut, traces of soy and wheat. Energy = 697 Kcal (Mini Bowl). (450 gms).",
    "imageId": "f50440fe62bcb66bc584e969084d8629",
    "inStock": 1,
    "isVeg": 1,
    "price": 16900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95565823",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565827",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565831",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.1",
    "ratingCount": "125 ratings",
    "ratingCountV2": "125"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "48338637",
    "name": "Dhaba Style Dal Tadka with Jeera Rice",
    "category": "Indian Bowls",
    "description": "Serves 1 | Wholesome yellow lentils cooked with onions, tomatoes and flavoured with tempered ghee and a medley of Indian spices. Served with cumin spiced long grain basmati rice. Comfort in a bowl to get you going! Contains NA. Energy : 723 Kcal (Regular Bowl) (Mini : 375 gms, Regular : 550 gms).",
    "imageId": "45a0f21bb54af074e4b520c7aaedb675",
    "inStock": 1,
    "isVeg": 1,
    "price": 15900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566120",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679006",
    "name": "Mini",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679007",
    "name": "Regular",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566123",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566125",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566129",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {
    "text": "Bestseller",
    "textColor": "#ffffff",
    "topBackgroundColor": "#d53d4c",
    "bottomBackgroundColor": "#b02331"
    },
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "isBestseller": true,
    "ratings": {
    "aggregatedRating": {
    "rating": "4.3",
    "ratingCount": "558 ratings",
    "ratingCountV2": "558"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "40576952",
    "name": "Good ol' Rajma Chawal",
    "category": "Indian Bowls",
    "description": "Serves 1 | Classic comfort bowl consisting of red kidney beans cooked in a mildly spicy onion tomato masala gravy, served with cumin spiced basmati rice. Contains milk . Energy : 769 Kcal (Regular Bowl), 501 Kcal (Mini Bowl) (Mini : 375 gms, Regular : 575 gms).",
    "imageId": "588985a937954151e1e3468430c0ec88",
    "inStock": 1,
    "isVeg": 1,
    "price": 16900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566226",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679179",
    "name": "Mini",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679180",
    "name": "Regular",
    "price": 6000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679181",
    "name": "Make it Guilt Free with Brown Rice (Mini)",
    "price": 3000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566228",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566231",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566233",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {
    "text": "Bestseller",
    "textColor": "#ffffff",
    "topBackgroundColor": "#d53d4c",
    "bottomBackgroundColor": "#b02331"
    },
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "isBestseller": true,
    "ratings": {
    "aggregatedRating": {
    "rating": "4.3",
    "ratingCount": "514 ratings",
    "ratingCountV2": "514"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "73826684",
    "name": "Punjabi Kadhi Chawal",
    "category": "Indian Bowls",
    "description": "A little tangy and much flavourful comes this Punjabi kadhi with crispy pakoras doused in a thick mildly spiced gram flour based gravy served with steamed rice. Contains milk. Energy : 723 Kcal (Regular Bowl), 526 Kcal (Mini Bowl) (Mini : 375 gms, Regular : 550 gms).",
    "imageId": "9ffe58a6f7e13c1ce1b53bd3e62a7dda",
    "inStock": 1,
    "isVeg": 1,
    "price": 15900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566482",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679419",
    "name": "Mini",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679420",
    "name": "Regular",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566483",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566484",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566487",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {
    "text": "Bestseller",
    "textColor": "#ffffff",
    "topBackgroundColor": "#d53d4c",
    "bottomBackgroundColor": "#b02331"
    },
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "isBestseller": true,
    "ratings": {
    "aggregatedRating": {
    "rating": "4.4",
    "ratingCount": "382 ratings",
    "ratingCountV2": "382"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "110236669",
    "name": "Classic Chicken Curry with Rice",
    "category": "Indian Bowls",
    "description": "Serves 1 | Food that speaks directly to the soul - bhuna chicken cooked in a rich tomato-onion gravy cooked with flavourful masalas and finished with coriander served with steamed rice. Contains nuts. Energy : 562 Kcal. (Mini Bowl), 846 Kcal (Regular Bowl) (Mini : 375 gms, Regular : 550 gms).",
    "imageId": "37b3610e94ce007e7df537e7a12d5c74",
    "inStock": 1,
    "price": 19900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566037",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92678995",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92678996",
    "name": "Regular",
    "price": 7000,
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92678997",
    "name": "Make it Guilt Free with Brown Rice (Mini)",
    "price": 4000,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566040",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566044",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566047",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.3",
    "ratingCount": "106 ratings",
    "ratingCountV2": "106"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "64671755",
    "name": "South Indian Style Egg Curry with Jeera Rice",
    "category": "Indian Bowls",
    "description": "Serves 1 | A mouthwatering Chennai speciality; hard boiled eggs cooked with traditional South Indian spices alongside lots of fresh curry leaves and mustard seeds. Served with aromatic cumin spiced rice. Contains Egg. Energy = 758 Kcal (Regular Bowl), 479 Kcal (Mini Bowl). (Mini : 375 gms, Regular : 550 gms).",
    "imageId": "e09c70926d7791e03d8cd0c907d48325",
    "inStock": 1,
    "price": 18900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566499",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679421",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679422",
    "name": "Regular",
    "price": 6000,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566501",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566502",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566504",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.2",
    "ratingCount": "100 ratings",
    "ratingCountV2": "100"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "53696568",
    "name": "Paneer Makhani Biryani",
    "category": "Indian Bowls",
    "description": "Serves 1 | We married the best of Dilli and  Hyderabad in this explosion of flavours. Butter paneer meets its match with flavourful biryani rice, served with a tangy yogurt raita and sliced onions. Contains milk, nut. Energy : 472 Kcal (Mini Bowl) 808 Kcal (Regular Bowl) (Mini : 505 gms, Regular : 705 gms).",
    "imageId": "7dc213b376b9dff5245ff7cfd9df1deb",
    "inStock": 1,
    "isVeg": 1,
    "price": 21900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566391",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679369",
    "name": "Mini",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679370",
    "name": "Regular",
    "price": 10000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566394",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566399",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566404",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {
    "text": "Bestseller",
    "textColor": "#ffffff",
    "topBackgroundColor": "#d53d4c",
    "bottomBackgroundColor": "#b02331"
    },
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "isBestseller": true,
    "ratings": {
    "aggregatedRating": {
    "rating": "4.4",
    "ratingCount": "321 ratings",
    "ratingCountV2": "321"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "53696650",
    "name": "Butter Chicken Biryani",
    "category": "Indian Bowls",
    "description": "We married the best of Dilli and  Hyderabad in this explosion of flavours. Butter chicken meets its match with flavourful biryani rice, served with a tangy yogurt raita and sliced onions. Contains milk, Nut. Energy : 883 Kcal (Regular Bowl), 570 Kcal (Mini Bowl). (Mini : 505 gms, Regular : 725 gms).",
    "imageId": "a434ebcabd6875264ecd58a1a3b38b76",
    "inStock": 1,
    "price": 22900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566586",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679476",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679477",
    "name": "Regular",
    "price": 11000,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566587",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566590",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566593",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566596",
    "groupName": "Sides",
    "choices": [
    {
    "id": "92678865",
    "name": "Mini Garlic Toast",
    "price": 4900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.4",
    "ratingCount": "76 ratings",
    "ratingCountV2": "76"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    }
    ]
    }
    }
    },
    {
    "card": {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
    "title": "Parotta Bowls",
    "itemCards": [
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "60073861",
    "name": "Nawabi Paneer Lababdar Parotta Bowl",
    "category": "Parotta Bowls",
    "description": "Serves 1 | Inspired from the kitchens of Punjab, soft cubes of paneer cooked in our flavourful Chef's special gravy seasoned with fragrant spices and served alongside soft, flaky conveniently chopped up, bite-sized pieces of your Choice of Parotta. Contains Milk, Nut, Wheat. Energy = 1187 Kcal (Regular Bowl), 791 Kcal (Mini Bowl). (Mini : 385 gms, Regular : 600 gms).",
    "imageId": "f4b258d10737a1050d4d3728473f893d",
    "inStock": 1,
    "isVeg": 1,
    "price": 20900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566375",
    "groupName": "Choice of Paratha",
    "choices": [
    {
    "id": "92679363",
    "name": "Laccha Paratha",
    "price": 1000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679364",
    "name": "Kerala Paratha",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566377",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679365",
    "name": "Mini",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679366",
    "name": "Regular",
    "price": 9000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566379",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566381",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566382",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.5",
    "ratingCount": "231 ratings",
    "ratingCountV2": "231"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "72052005",
    "name": "Classic Chicken Curry Kerala Parotta Bowl",
    "category": "Parotta Bowls",
    "description": "Serves 1 | Bhuna chicken cooked in a rich tomato-onion gravy cooked with flavourful masalas and finished with coriander served with kerela parotta. Contains : wheat, nut. Energy : 758. 3 Kcal (Mini Bowl), 1198 Kcal (Regular Bowl) (Mini : 385 gms, Regular : 600 gms).",
    "imageId": "9a7c22f34875a75106d50ce0ecbe6c29",
    "inStock": 1,
    "price": 21900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95565886",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92678870",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92678871",
    "name": "Regular",
    "price": 6000,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95565890",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565896",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95565899",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.5",
    "ratingCount": "231 ratings",
    "ratingCountV2": "231"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "72052004",
    "name": "Drunken Chicken Kerala Parotta Bowl",
    "category": "Parotta Bowls",
    "description": "Serves 1 | Tender chunks of chicken cooked in a Chef's special flavorful Asian sauce (tinch of wine) and served along with kerela parotta. Contains wheat, traces of soy, fish crustaceans, molluscs (sauce) . Energy : 703 Kcal (Mini Bowl) (Mini : 385 gms, Regular : 600 gms).",
    "imageId": "ef08dd48636733e12cb31acee4362ef4",
    "inStock": 1,
    "price": 21900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566194",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679173",
    "name": "Mini",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679174",
    "name": "Regular",
    "price": 9000,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566195",
    "groupName": "Sides and Starters",
    "choices": [
    {
    "id": "92678848",
    "name": "Chilli Paneer (100 g)",
    "price": 9900,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678849",
    "name": "Falafel",
    "price": 6900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678850",
    "name": "Peri Peri Chicken (100 g)",
    "price": 12900,
    "isEnabled": 1
    }
    ],
    "maxAddons": 3,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566200",
    "groupName": "Beverages",
    "choices": [
    {
    "id": "92678851",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "price": 8570,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678853",
    "name": "Coca Cola Can (330ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678852",
    "name": "Buttermilk",
    "price": 6200,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678854",
    "name": "Thums Up Can (330 ml)",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678855",
    "name": "Raw Pressery Alphonso Mango Juice",
    "price": 6300,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 5,
    "maxFreeAddons": -1
    },
    {
    "groupId": "95566202",
    "groupName": "Desserts",
    "choices": [
    {
    "id": "92678856",
    "name": "Mango Pudding",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678857",
    "name": "Gajar Halwa",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678858",
    "name": "Bailey's Chocolate Mousse Cake",
    "price": 14900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678859",
    "name": "Gulab Jamun",
    "price": 7900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678860",
    "name": "Kesariya Rasmalai",
    "price": 8900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678861",
    "name": "Triple Ripple Chocolate Cake",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678862",
    "name": "Rabdi Jamun and Boondi Drizzle",
    "price": 9900,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 7,
    "maxFreeAddons": -1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.2",
    "ratingCount": "62 ratings",
    "ratingCountV2": "62"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    }
    ]
    }
    }
    },
    {
    "card": {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
    "title": "BIG Meal BIG Saving",
    "itemCards": [
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "112902090",
    "name": "Butter Chicken Biryani + Choice of  Starter + Choice of  Dessert",
    "category": "BIG Meal BIG Saving",
    "description": "Enjoy Butter Chicken Biryani along with zesty starter and dessert of your choice.",
    "imageId": "e1776a8b9253bf896e02b694da7f85d6",
    "inStock": 1,
    "price": 39900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566575",
    "groupName": "Select Your Starter",
    "choices": [
    {
    "id": "92679470",
    "name": "Peri Peri Chicken (100 g)",
    "price": 1000,
    "isEnabled": 1
    },
    {
    "id": "92679471",
    "name": "Falafel",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679469",
    "name": "Chilli Paneer (100 g)",
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566576",
    "groupName": "Select Your Dessert",
    "choices": [
    {
    "id": "92679472",
    "name": "Angoori Rasmalai",
    "price": 1000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679473",
    "name": "Gajar Ka halwa",
    "price": 2000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679474",
    "name": "Tripple Chocolate cake",
    "price": 2000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679475",
    "name": "Gulab Jamun (1 Pc)",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.4",
    "ratingCount": "5 ratings",
    "ratingCountV2": "5"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "112902091",
    "name": "Paneer Makhani Biryani + Choice of  Starter + Choice of  Dessert",
    "category": "BIG Meal BIG Saving",
    "description": "Relish Paneer Makhani Biryani with an appetizer and dessert of your choice from our top sellers.",
    "imageId": "8a28147e32f77563156d17ea3b8bb1e7",
    "inStock": 1,
    "isVeg": 1,
    "price": 36900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566577",
    "groupName": "Select Your Starter",
    "choices": [
    {
    "id": "92679470",
    "name": "Peri Peri Chicken (100 g)",
    "price": 1000,
    "isEnabled": 1
    },
    {
    "id": "92679471",
    "name": "Falafel",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679469",
    "name": "Chilli Paneer (100 g)",
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566579",
    "groupName": "Select Your Dessert",
    "choices": [
    {
    "id": "92679472",
    "name": "Angoori Rasmalai",
    "price": 1000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679473",
    "name": "Gajar Ka halwa",
    "price": 2000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679474",
    "name": "Tripple Chocolate cake",
    "price": 2000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679475",
    "name": "Gulab Jamun (1 Pc)",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.5",
    "ratingCount": "4 ratings",
    "ratingCountV2": "4"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "113536644",
    "name": "Choice of 2 Classic Veg bowls",
    "category": "BIG Meal BIG Saving",
    "description": "The perfect valyue meal; enjoy any two bowls of your choice from our hot favourites.",
    "imageId": "c0f36cce1fd7e4f9153341ac0fab5465",
    "inStock": 1,
    "isVeg": 1,
    "price": 44900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566630",
    "groupName": "Select Your 1st Bowl",
    "choices": [
    {
    "id": "92679528",
    "name": "Nawabi Paneer Lababdar with Matar Pulao",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679529",
    "name": "Paneer Makhani Biryani",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679530",
    "name": "Classic Mac & Cheese Pasta",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679531",
    "name": "Creamy Mushroom Florentine Spaghetti",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679532",
    "name": "Nawabi Paneer Lababdar Kerala Parotta Bowl",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566632",
    "groupName": "Select Your 2nd Bowl",
    "choices": [
    {
    "id": "92679533",
    "name": "Nawabi Paneer Lababdar with Matar Pulao",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679534",
    "name": "Paneer Makhani Biryani",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679535",
    "name": "Classic Mac & Cheese Pasta",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679536",
    "name": "Creamy Mushroom Florentine Spaghetti",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679537",
    "name": "Nawabi Paneer Lababdar Kerala Parotta Bowl",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.3",
    "ratingCount": "11 ratings",
    "ratingCountV2": "11"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "113536646",
    "name": "Choice of 2 Classic Non-Veg Bowls",
    "category": "BIG Meal BIG Saving",
    "description": "Two is always better than one; enjoy any two bowls of your choice from our top sellers.",
    "imageId": "54d91d790d9091ed4c0fe334bbbc4bfa",
    "inStock": 1,
    "price": 45900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566626",
    "groupName": "Select Your 1st Bowl",
    "choices": [
    {
    "id": "92679519",
    "name": "Caribbean Grilled Chicken with Herbed Rice",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679518",
    "name": "Peri Peri Chicken with Egg Corn Rice",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679520",
    "name": "Malaysian Chicken Curry with Selasih Rice",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679521",
    "name": "Butter Chicken Biryani",
    "price": 2000,
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679522",
    "name": "Butter Chicken Mac & Cheese Pasta",
    "price": 1000,
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566627",
    "groupName": "Select Your 2nd Bowl",
    "choices": [
    {
    "id": "92679523",
    "name": "Peri Peri Chicken with Egg Corn Rice",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679524",
    "name": "Malaysian Chicken Curry with Selasih Rice",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679525",
    "name": "Butter Chicken Biryani",
    "price": 2000,
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679526",
    "name": "Butter Chicken Mac & Cheese Pasta",
    "price": 1000,
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679527",
    "name": "Caribbean Grilled Chicken with Herbed Rice",
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.3",
    "ratingCount": "8 ratings",
    "ratingCountV2": "8"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "113536648",
    "name": "Choice of Veg bowl & Drink",
    "category": "BIG Meal BIG Saving",
    "description": "Feast on your favourite veg bowl along with a beverage of your choice. The perfect meal combo!",
    "imageId": "30ee7b5a1a358861293d2102b69afd7d",
    "inStock": 1,
    "isVeg": 1,
    "price": 28900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566636",
    "groupName": "Select Your Favourite Bowl",
    "choices": [
    {
    "id": "92679511",
    "name": "Nawabi Paneer Lababdar with Matar Pulao",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679512",
    "name": "Paneer Makhani Biryani",
    "price": 1000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679513",
    "name": "Classic Mac & Cheese Pasta",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679514",
    "name": "Creamy Mushroom Florentine Spaghetti",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679515",
    "name": "Nawabi Paneer Lababdar Kerala Parotta Bowl",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566637",
    "groupName": "Select Your Drink",
    "choices": [
    {
    "id": "92679538",
    "name": "Zero Coke Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679539",
    "name": "Coca-Cola Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679540",
    "name": "Sprite Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679541",
    "name": "Thums Up Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {}
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "113536647",
    "name": "Choice of Non-veg Bowl & Drink",
    "category": "BIG Meal BIG Saving",
    "description": "Treat yourself with your favourite bowl and refreshing beverage of your choice.",
    "imageId": "72bf1e42652d7737f2408c9159ae4403",
    "inStock": 1,
    "price": 29900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566634",
    "groupName": "Select Your Favourite Bowl",
    "choices": [
    {
    "id": "92679478",
    "name": "Peri Peri Chicken with Egg Corn Rice",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679479",
    "name": "Malaysian Chicken Curry with Selasih Rice",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679480",
    "name": "Butter Chicken Biryani",
    "price": 2000,
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679481",
    "name": "Butter Chicken Mac & Cheese Pasta",
    "price": 1000,
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679482",
    "name": "Caribbean Grilled Chicken with Herbed Rice",
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566635",
    "groupName": "Select Your Drink",
    "choices": [
    {
    "id": "92679538",
    "name": "Zero Coke Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679539",
    "name": "Coca-Cola Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679540",
    "name": "Sprite Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679541",
    "name": "Thums Up Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.7",
    "ratingCount": "7 ratings",
    "ratingCountV2": "7"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "113536652",
    "name": "Loaded Meal with Veg Bowl, Dessert & Drink",
    "category": "BIG Meal BIG Saving",
    "description": "Build your own meal with your favourite bowl from our top sellers along with a dessert and beverage of your choice. A fully loaded meal!",
    "imageId": "7ee6b788f3f6ceb27bc52ea77151deb1",
    "inStock": 1,
    "isVeg": 1,
    "price": 36900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566681",
    "groupName": "Select Your Favourite Bowl",
    "choices": [
    {
    "id": "92679511",
    "name": "Nawabi Paneer Lababdar with Matar Pulao",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679512",
    "name": "Paneer Makhani Biryani",
    "price": 1000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679513",
    "name": "Classic Mac & Cheese Pasta",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679514",
    "name": "Creamy Mushroom Florentine Spaghetti",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679515",
    "name": "Nawabi Paneer Lababdar Kerala Parotta Bowl",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566682",
    "groupName": "Select Your Dessert",
    "choices": [
    {
    "id": "92679484",
    "name": "Angoori Rasmalai",
    "price": 1000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679485",
    "name": "Gajar Ka halwa",
    "price": 2000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679486",
    "name": "Tripple Chocolate cake",
    "price": 2000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679487",
    "name": "Gulab Jamun (1 Pc)",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566683",
    "groupName": "Select Your Drink",
    "choices": [
    {
    "id": "92679538",
    "name": "Zero Coke Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679539",
    "name": "Coca-Cola Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679540",
    "name": "Sprite Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679541",
    "name": "Thums Up Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {}
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "113536649",
    "name": "Loaded Meal with Non- Veg Bowl, Dessert & Drink",
    "category": "BIG Meal BIG Saving",
    "description": "Create a fully loaded meal with your favourite bowl from our top sellers along with a dessert and beverage of your choice.",
    "imageId": "b71050d17771a70d8176a651b9b7ad9b",
    "inStock": 1,
    "price": 37900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566678",
    "groupName": "Select Your Favourite Bowl",
    "choices": [
    {
    "id": "92679478",
    "name": "Peri Peri Chicken with Egg Corn Rice",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679479",
    "name": "Malaysian Chicken Curry with Selasih Rice",
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679480",
    "name": "Butter Chicken Biryani",
    "price": 2000,
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679481",
    "name": "Butter Chicken Mac & Cheese Pasta",
    "price": 1000,
    "inStock": 1,
    "isEnabled": 1
    },
    {
    "id": "92679482",
    "name": "Caribbean Grilled Chicken with Herbed Rice",
    "inStock": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566679",
    "groupName": "Select Your Dessert",
    "choices": [
    {
    "id": "92679484",
    "name": "Angoori Rasmalai",
    "price": 1000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679485",
    "name": "Gajar Ka halwa",
    "price": 2000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679486",
    "name": "Tripple Chocolate cake",
    "price": 2000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679487",
    "name": "Gulab Jamun (1 Pc)",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566680",
    "groupName": "Select Your Drink",
    "choices": [
    {
    "id": "92679538",
    "name": "Zero Coke Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679539",
    "name": "Coca-Cola Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679540",
    "name": "Sprite Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679541",
    "name": "Thums Up Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "NONVEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {}
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "113536651",
    "name": "Indulgent Veg Meal with Bowl, Starter & Drink",
    "category": "BIG Meal BIG Saving",
    "description": "Treat yourself with an indulgent meal! Pick a bowl from our curated list and enjoy it with an appetizer and beverage of your choice.",
    "imageId": "ac791e12ec2cb85a329a2f5fff0e7015",
    "inStock": 1,
    "isVeg": 1,
    "price": 35900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566643",
    "groupName": "Select Your Starter",
    "choices": [
    {
    "id": "92679516",
    "name": "Chilli Paneer (100 g)",
    "price": 1000,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679517",
    "name": "Falafel",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566641",
    "groupName": "Select Your Favourite Bowl",
    "choices": [
    {
    "id": "92679511",
    "name": "Nawabi Paneer Lababdar with Matar Pulao",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679512",
    "name": "Paneer Makhani Biryani",
    "price": 1000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679513",
    "name": "Classic Mac & Cheese Pasta",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679514",
    "name": "Creamy Mushroom Florentine Spaghetti",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679515",
    "name": "Nawabi Paneer Lababdar Kerala Parotta Bowl",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566645",
    "groupName": "Select Your Drink",
    "choices": [
    {
    "id": "92679538",
    "name": "Zero Coke Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679539",
    "name": "Coca-Cola Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679540",
    "name": "Sprite Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679541",
    "name": "Thums Up Can ( 330 ml )",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {}
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "113536645",
    "name": "Big Meal with Veg Bowl, Starter & Dessert",
    "category": "BIG Meal BIG Saving",
    "description": "Give in to your cravings with a delightful meal - pick a bowl of your choice from our best-sellers and enjoy it with an appetizer and dessert.",
    "imageId": "909b114aae25b875aa3defc2c945ab66",
    "inStock": 1,
    "isVeg": 1,
    "price": 37900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566621",
    "groupName": "Select Your Starter",
    "choices": [
    {
    "id": "92679516",
    "name": "Chilli Paneer (100 g)",
    "price": 1000,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679517",
    "name": "Falafel",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566622",
    "groupName": "Select Your Dessert",
    "choices": [
    {
    "id": "92679484",
    "name": "Angoori Rasmalai",
    "price": 1000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679485",
    "name": "Gajar Ka halwa",
    "price": 2000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679486",
    "name": "Tripple Chocolate cake",
    "price": 2000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679487",
    "name": "Gulab Jamun (1 Pc)",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    },
    {
    "groupId": "95566620",
    "groupName": "Select Your Favourite Bowl",
    "choices": [
    {
    "id": "92679511",
    "name": "Nawabi Paneer Lababdar with Matar Pulao",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679512",
    "name": "Paneer Makhani Biryani",
    "price": 1000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679513",
    "name": "Classic Mac & Cheese Pasta",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679514",
    "name": "Creamy Mushroom Florentine Spaghetti",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679515",
    "name": "Nawabi Paneer Lababdar Kerala Parotta Bowl",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {}
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    }
    ]
    }
    }
    },
    {
    "card": {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
    "title": "Sides",
    "itemCards": [
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "110033763",
    "name": "Falafel",
    "category": "Sides",
    "description": "Tasteful fritters made of ground chickpeas and herbs. A popular Middle Eastern snack. Contains wheat. Energy : 147 Kcal.",
    "imageId": "0cb8efec0b18434db4359b213f8a747f",
    "inStock": 1,
    "isVeg": 1,
    "price": 6900,
    "variants": {},
    "variantsV2": {},
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "5.0",
    "ratingCount": "3 ratings",
    "ratingCountV2": "3"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "101903943",
    "name": "Mini Garlic Toast",
    "category": "Sides",
    "description": "Serves 1 | Crispy rusk flavoured with garlic, chilli flakes and oregano. A perfect all-day munchie! (22 gms).",
    "imageId": "a12dc8c560066237e64483c55a8bc2fe",
    "inStock": 1,
    "isVeg": 1,
    "price": 5900,
    "variants": {},
    "variantsV2": {},
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.1",
    "ratingCount": "17 ratings",
    "ratingCountV2": "17"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    }
    ]
    }
    }
    },
    {
    "card": {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
    "title": "Desserts",
    "itemCards": [
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "116779372",
    "name": "Mango Pudding",
    "category": "Desserts",
    "description": "A delightful mango dessert layered with sponge cake, cream and mango pulp. Energy ; 427Kcal /100 gram. Contains\tWheat, Soy, and Milk.",
    "imageId": "a83830f2959aa33528bc1270116db2d9",
    "inStock": 1,
    "isVeg": 1,
    "price": 9900,
    "variants": {},
    "variantsV2": {},
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "5.0",
    "ratingCount": "4 ratings",
    "ratingCountV2": "4"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "109163421",
    "name": "Gulab Jamun",
    "category": "Desserts",
    "description": "Serves 1 | These soft little pleasures soaked in rose and saffron flavoured sugar syrup and garnished with dry fruit shavings is what deliciousness is all about. Good for 1. Contains milk, nuts, wheat. Energy : 278 Kcal (90 gms).",
    "imageId": "2735b045091b521eb98d029d79d50c80",
    "inStock": 1,
    "isVeg": 1,
    "price": 7900,
    "variants": {},
    "variantsV2": {},
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.6",
    "ratingCount": "5 ratings",
    "ratingCountV2": "5"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "117846970",
    "name": "Choco Nutty Mousse",
    "category": "Desserts",
    "description": "Smooth and creamy chocolate mousse topped with roasted almonds. Contains nuts and dairy.",
    "imageId": "bf60ec7af959ef72e250ed9fde4af0aa",
    "inStock": 1,
    "isVeg": 1,
    "price": 8900,
    "variants": {},
    "variantsV2": {},
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {}
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "7363378",
    "name": "Kesariya Rasmalai",
    "category": "Desserts",
    "description": "Serves 1 | Soft and spongy cottage cheese dumplings soaked in a dry fruit aced creamy saffron milk rabri. Got to love all things old school. Contains milk, nuts. Energy : 121 Kcal.",
    "imageId": "35a75618d69ccb1a2c525d30ac357f70",
    "inStock": 1,
    "isVeg": 1,
    "price": 8900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566356",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679361",
    "name": "Cup",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679362",
    "name": "Jar",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.3",
    "ratingCount": "119 ratings",
    "ratingCountV2": "119"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "13064716",
    "name": "Angoori Rasmalai",
    "category": "Desserts",
    "description": "Serves 1 | Angoori Rasmalai is a traditional Bengali sweet soaked in a mouth watering milk based gravy. It's a jar of love. Contains milk, nuts. Energy : 125 Kcal (Cup).",
    "imageId": "f72b65d0dc681b5fceed3b37119bd1ea",
    "inStock": 1,
    "isVeg": 1,
    "price": 8900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95565820",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92678846",
    "name": "Cup",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92678847",
    "name": "Jar",
    "price": 5000,
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.5",
    "ratingCount": "100 ratings",
    "ratingCountV2": "100"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "44823016",
    "name": "Gajar Ka Halwa",
    "category": "Desserts",
    "description": "Serves 1 | Mum's oh-so-yum Gajar Ka Halwa simply made with shredded red carrots in warm ghee, sugar and a blend of winter spices. Grab a spoonful with the chopped dry fruits and the wafting scent of cardamom and cuddle back in bed. Contains milk, nuts. Energy : 291. 99 Kcal. (100 gms).",
    "imageId": "eddfaa5f324bd0e19bc722a08c47b070",
    "inStock": 1,
    "isVeg": 1,
    "price": 9900,
    "variants": {},
    "variantsV2": {},
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "3.5",
    "ratingCount": "62 ratings",
    "ratingCountV2": "62"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "44823017",
    "name": "Rabdi Jamun and a Boondi Drizzle",
    "category": "Desserts",
    "description": "Serves 1 | Angoori gulab jamun topped with creamy homemade radbi, sugary drops of pillowy boondi and finished off with slivers of pistachios. Good for 1. Contains milk, nuts. Energy : 287.72 Kcal. (100 gms).",
    "imageId": "dbad796693b46e602ed7e0f90fd131cc",
    "inStock": 1,
    "isVeg": 1,
    "price": 9900,
    "variants": {},
    "variantsV2": {},
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.3",
    "ratingCount": "75 ratings",
    "ratingCountV2": "75"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "59305952",
    "name": "Triple Ripple Chocolate Cake",
    "category": "Desserts",
    "description": "Sink your spoon into this pool of Dutch dark chocolate; layers of fluffy chocolate sponge tucked amidst ripples of rich, whipped chocolate truffle, finished with delicate shavings of white and dark chocolate. Good for 2. Contains Milk, Wheat, Nut. Energy = 810 Kcal.",
    "imageId": "8d579f6c6ffff8652dbb2bb9686344c4",
    "inStock": 1,
    "isVeg": 1,
    "price": 9900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566522",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679425",
    "name": "Cup (Small)",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679426",
    "name": "Jar (Large)",
    "price": 5000,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.3",
    "ratingCount": "21 ratings",
    "ratingCountV2": "21"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "72671282",
    "name": "Red Velvet Pastry Jar",
    "category": "Desserts",
    "description": "Serves 1 | Dip your spoon into this red velvet cake layered with smooth cream cheese from the comfort of your couch! Contains milk, wheat. Energy : 516 Kcal. (100 gms).",
    "imageId": "0732b5cc401bc92ec134483a6e8eee54",
    "inStock": 1,
    "isVeg": 1,
    "price": 12900,
    "variants": {},
    "variantsV2": {},
    "itemAttribute": {
    "vegClassifier": "VEG",
    "portionSize": "Serves 1"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "5.0",
    "ratingCount": "24 ratings",
    "ratingCountV2": "24"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "9747986",
    "name": "Bailey's Chocolate Mousse",
    "category": "Desserts",
    "description": "A delicious concoction of Chef's special sinful chocolate mousse not spiked with Bailey's but finished off with whipped cream. All the happiness you need is right here. Contains milk, nuts. Energy : 279 Kcal. (Note : Its just a product name without any bailey)",
    "imageId": "71655dcbee56530249d62da34aa8a350",
    "inStock": 1,
    "isVeg": 1,
    "price": 15900,
    "variants": {},
    "variantsV2": {},
    "addons": [
    {
    "groupId": "95566574",
    "groupName": "Quantity",
    "choices": [
    {
    "id": "92679467",
    "name": "Cup",
    "inStock": 1,
    "isVeg": 1,
    "isEnabled": 1
    },
    {
    "id": "92679468",
    "name": "Jar",
    "price": 5000,
    "isVeg": 1,
    "isEnabled": 1
    }
    ],
    "maxAddons": 1,
    "maxFreeAddons": -1,
    "minAddons": 1
    }
    ],
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {}
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    }
    ]
    }
    }
    },
    {
    "card": {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
    "title": "Beverages!",
    "itemCards": [
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "109990195",
    "name": "Thums Up Can ( 330 ml )",
    "category": "Beverages!",
    "description": "India's unbeaten cold drink choice for decades - raise the excitement of any occasion to toofani levels with power-packed Thums Up. *Packaged products sold by Venkatesh Trading Co. Country of origin: India Energy= 129 Kcal/pack (as per label) Contains caffiene. Please read label for more specific declaration",
    "inStock": 1,
    "isVeg": 1,
    "price": 5000,
    "variants": {},
    "variantsV2": {},
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "5.0",
    "ratingCount": "3 ratings",
    "ratingCountV2": "3"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "109990196",
    "name": "Sprite Can ( 330 ml )",
    "category": "Beverages!",
    "description": "The lemony taste of Sprite will always keep you refreshed. *Packaged products sold by Venkatesh Trading Co. \n Country of origin : India \n . Energy : 144 Kcal/pack (as per label) Please read label for more specific declaration",
    "imageId": "5db8488450c26abd9a38cf18fdc0c905",
    "inStock": 1,
    "isVeg": 1,
    "price": 5000,
    "variants": {},
    "variantsV2": {},
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.8",
    "ratingCount": "5 ratings",
    "ratingCountV2": "5"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "109990197",
    "name": "Zero Coke Can ( 330 ml )",
    "category": "Beverages!",
    "description": "The real Coke taste you love - minus the sugar and calories. *Packaged products sold by Venkatesh Trading Co. Country of origin : India. Energy : 1 Kcal/pack (as per label). Contains caffeine. Please read label for more specific declaration.",
    "imageId": "c472b586d2e130cdcd7fb49f3cb987b0",
    "inStock": 1,
    "isVeg": 1,
    "price": 5000,
    "variants": {},
    "variantsV2": {},
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.5",
    "ratingCount": "26 ratings",
    "ratingCountV2": "26"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "109990208",
    "name": "Coca-Cola Can ( 330 ml )",
    "category": "Beverages!",
    "description": "Meals seem incomplete without a chilled and bubbling can of Coca-Cola. *Packaged products sold by Venkatesh Trading Co. Country of origin : India . Energy : 145Kcal/pack (as per label) Contains caffeine. Please read label for more specific declaration.",
    "imageId": "98d4c7629647402d8a3ce2b473cb494f",
    "inStock": 1,
    "isVeg": 1,
    "price": 5000,
    "variants": {},
    "variantsV2": {},
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.5",
    "ratingCount": "13 ratings",
    "ratingCountV2": "13"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "109990204",
    "name": "Butter milk",
    "category": "Beverages!",
    "description": "Beat the summer heat with our refreshing and tasty buttermilk. I am sure you would love it! Contains milk . Energy : 87 Kcal",
    "imageId": "525aa8fa68af6ed5fedf2689275bfdbf",
    "inStock": 1,
    "isVeg": 1,
    "price": 6200,
    "variants": {},
    "variantsV2": {},
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.5",
    "ratingCount": "23 ratings",
    "ratingCountV2": "23"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "109983575",
    "name": "Sunfeast Dark Fantasy Chocolate Shake",
    "category": "Beverages!",
    "description": "Indulgent, Irresistable chocolate shake from Sunfeast Dark Fantasy",
    "imageId": "dad2209b1478fbfe9d5f8d0ae8b14cc9",
    "inStock": 1,
    "isVeg": 1,
    "price": 8570,
    "variants": {},
    "variantsV2": {},
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.8",
    "ratingCount": "22 ratings",
    "ratingCountV2": "22"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    },
    {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
    "info": {
    "id": "109990199",
    "name": "Raw Pressery  - Tender Coconut Water",
    "category": "Beverages!",
    "description": "Your favourite go-to natural drink; Raw Coconut Water is an everyday essential for you to recharge and rehydrate *Packaged products sold by Venkatesh Trading Co.  Country of origin : India. Energy : 49. 56 Kcal/pack (as per label).",
    "imageId": "7cbf0095d07bb17f02db22837323aa5f",
    "inStock": 1,
    "isVeg": 1,
    "price": 6300,
    "variants": {},
    "variantsV2": {},
    "itemAttribute": {
    "vegClassifier": "VEG"
    },
    "ribbon": {},
    "type": "ITEM",
    "itemBadge": {},
    "badgesV2": {},
    "ratings": {
    "aggregatedRating": {
    "rating": "4.5",
    "ratingCount": "11 ratings",
    "ratingCountV2": "11"
    }
    }
    },
    "analytics": {},
    "hideRestaurantDetails": true
    }
    }
    ]
    }
    }
    },
    {
    "card": {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
    "type": "FSSAI",
    "imageId": "fssai_final_edss9i",
    "text": [
    "License No. 11218333002027"
    ]
    }
    }
    },
    {
    "card": {
    "card": {
    "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
    "name": "The Bowl Company",
    "area": "Marathahalli",
    "completeAddress": "sai tower,1st floor munnekolala varthur hobli,maratahalli,bangalore-560036"
    }
    }
    }
    ]
    }
    }
    }
    }
    ],
    "firstOffsetRequest": true
    },
    "tid": "20accd0d-1619-48a2-aa35-6fb179e5add6",
    "sid": "7nv0f848-ee04-4ec4-acc2-efe3bd7bb2ff",
    "deviceId": "e140ee10-50e7-10db-7831-10947e3bbbf5",
    "csrfToken": "h6zKMELlp1mh-EgHfZAf14XCf7mEL66lee1caubs"
    }